export default class ApiError {
  code: number;
  message: string;
  status?: number;
  body?: any;

  constructor(code: number, message: string) {
    this.code = code;
    this.message = message;
  }
}